import { Observable } from "@reactivex/rxjs";
import { EntityService } from "../entity.v2/entity-service";
import { EntityResult } from "../entity.v2/entity-service";
import { AgentProfileEntityService } from "./agent-profile-entity-service";
import { AgentProfileEntity } from "./agent-profile-entity-model";
import { MyTeamsIdentifier, MyTeamsEntity, TeamServiceModel } from "./my-teams-entity-model";
import { ConfigWithStartAndEnd } from "../../../ShellCommon/logger/http-interceptor";
import { ServiceDeskConfig } from "../../Startup/serviceDeskConfig";

export interface MyTeamsEntityService {
  /** Gets the teams the current agent is assigned to */
  getMyTeams(): Observable<MyTeamsEntity>;
}

export class MyTeamsEntityServiceImplementation
  extends EntityService<MyTeamsIdentifier, MyTeamsEntity>
  implements MyTeamsEntityService
{
  // @ngInject
  constructor(
    private agentProfileEntityService: AgentProfileEntityService,
    private $http: ng.IHttpService,
    private sdConfig: ServiceDeskConfig
  ) {
    super("myTeams");
  }

  public getMyTeams(): Observable<MyTeamsEntity> {
    return this.agentProfileEntityService
      .GetAgentProfile()
      .flatMap((agentProfile: AgentProfileEntity) => this.getValue(new MyTeamsIdentifier(agentProfile.id), "get"));
  }

  protected refresh(key: MyTeamsIdentifier): Observable<EntityResult<MyTeamsEntity>> {
    let url = `${this.sdConfig.agentServiceUrl}teams/my`;
    let config = <ConfigWithStartAndEnd>{
      dependencyName: "AgentService",
      operationName: "MyTeams.Get",
      dependencyOperationName: "MyTeams.Get"
    };
    let getRequest = this.$http.get(url, config).then((response: ng.IHttpPromiseCallbackArg<TeamServiceModel[]>) => {
      let myTeamsEntity: MyTeamsEntity = {
        teams: response.data.map((team) => ({
          Id: team.id,
          Name: team.Name,
          SupportAreaPaths: team.SupportAreaPaths,
          TeamLeads: team.TeamLeads,
          TeamManagers: team.TeamManagers,
          AgentIds: team.AgentIds
        }))
      };
      return <EntityResult<MyTeamsEntity>>{
        eventName: "refresh",
        entityValue: myTeamsEntity
      };
    });
    return Observable.fromPromise(getRequest);
  }
}
